import React from 'react';
import { Label } from '@nooz-optics/nooz-components-lib';
import { formatContentfulComponentProps } from '../../../../utils/globals';
import { Image } from '../../../UI/Media';

export const FeaturesSquareImages = ({ label, body, list }) => (
  <div className='py-20 sm:py-20'>
    <div className='border-t pb-6' />
    <div className='max-w-3xl'>
      <Label
        {...label}
        color={{ classname: 'gray-800' }}
        weight='medium'
        size='4xl'
      />
      <div className='mt-4'>
        <Label {...body} />
      </div>
    </div>

    <div className='mt-6 grid items-start grid-cols-2 gap-y-16 gap-x-6 sm:mt-16 sm:grid-cols-2 lg:grid-cols-4 lg:gap-x-8'>
      {list.items.map((featureComponent) => {
        const feature = formatContentfulComponentProps(featureComponent);
        return (
          <div
            key={feature.name}
            className='flex flex-col-reverse'>
            <div className='mt-6'>
              <Label
                {...feature.label}
                color={{ classname: 'gray-800' }}
                size='lg'
                weight='medium'
              />
              <div className='mt-2'>
                <Label
                  {...feature.body}
                  size='base'
                />
              </div>
            </div>
            <div className='aspect-w-1 aspect-h-1 rounded-lg flex items-center bg-gray-100 overflow-hidden'>
              <Image
                {...feature.image}
                objectFit='cover'
              />
            </div>
          </div>
        );
      })}
    </div>
  </div>
);
